import { CalendarDay } from '@/utils/interfaces';
import { SlotStatus } from '@/utils/enums';

export function convertDayNumberToName (day: number): string {
  switch (day) {
  case 0: return 'Niedziela';
  case 1: return 'Poniedziałek';
  case 2: return 'Wtorek';
  case 3: return 'Środa';
  case 4: return 'Czwartek';
  case 5: return 'Piątek';
  case 6: return 'Sobota';
  default: return '';
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function mapCalendarSlots (obj: any): CalendarDay[] {
  return Object.keys(obj).map(key => {
    return {
      date: key,
      slots: obj[key]
    };
  })
    .map(el => {
      const d = new Date(el.date);
      const dString = el.date.split('-');
      return {
        dayMonthLabel: `${dString[2]}.${dString[1]}`,
        dayNameLabel: convertDayNumberToName(d.getDay()),
        slots: el.slots.map((slot: any) => {
          return {
            ...slot,
            fullDate: `${el.date} ${slot.date}`
          };
        })
      };
    })
    .filter(el => !!el.slots.length);
}

export function getDateFrom (days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) { month = '0' + month; }
  if (day.length < 2) { day = '0' + day; }

  return [
    year,
    month,
    day
  ].join('-');
}

export function isOdd (num: number): any { return num % 2; }

export function numberToStringFormat (num: number): string {
  let str = num.toString();

  if (str.length === 1) {
    str = `0${str}`;
  }

  return str;
}
export function createSlots (days: number, slots: number, startingHour: number): CalendarDay[] {
  return new Array(days).fill(null)
    .map((el, index) => {
      const d = new Date();
      d.setDate(d.getDate() + index);
      return {
        dayMonthLabel: `${numberToStringFormat(d.getDate())}.${numberToStringFormat(d.getMonth() + 1)}`,
        dayNameLabel: convertDayNumberToName(d.getDay()),
        slots: new Array(slots).fill(null)
          .map((e, i) => {
            d.setHours(startingHour + (i >= 2 ? i / 2 : 0), isOdd(i) ? 30 : 0);
            const date = `${numberToStringFormat(d.getHours())}:${numberToStringFormat(d.getMinutes())}`;
            return {
              date: date,
              duration: 30,
              fullDate: `${d.getFullYear()}-${numberToStringFormat(d.getMonth() + 1)}-${numberToStringFormat(d.getDate())} ${date}`,
              status: SlotStatus.AVAILABLE
            };
          })
      };
    });
}
